export default {
  titleAdd: 'New employer',
  titleEdit: 'Edit employer',
  subTitleAddAndEdit: 'Please enter the company name and type',
  buttonAddAdd: 'Add Employer',
  buttonAddEdit: 'Save changes',
  buttonCancel: 'Cancel',
  placeholder: {
    name: 'Name',
    type: 'Type',
  },
};
